import axiosApi, { setHeader } from "api/root.api";

export const getProject = async (token, projectId) => {
  const urlEnd = `/scan/editor/project/v1/${projectId}`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
